import { useState, useEffect } from "react";
import useInView from "../hooks/useInView";

/**
 * AnimCount
 * Animates a number from 0 to `n` when scrolled into view.
 * @param {number} n - the target number to count to
 */
const AnimCount = ({ n }) => {
  const [val, setVal] = useState(0);
  const [ref, visible] = useInView(0.5);

  useEffect(() => {
    if (!visible) return;

    let v = 0;
    const step = Math.max(1, Math.ceil(n / 48));
    const timer = setInterval(() => {
      v = Math.min(v + step, n);
      setVal(v);
      if (v >= n) clearInterval(timer);
    }, 16);

    return () => clearInterval(timer);
  }, [visible, n]);

  return <span ref={ref}>{val}</span>;
};

export default AnimCount;